import React, { createContext, useState } from "react";
import { Trip } from "interfaces/trip.interfaces";

interface TripContextType {
  setTrip: (trip: Trip) => void;
  trip: any | null;
}

export const TripContext = createContext<TripContextType>({
  trip: null,
  setTrip: () => {},
});

export const TripProvider = ({ children }: any): React.ReactElement => {
  const [trip, setTrip] = useState<any | null>({});
  return <TripContext.Provider value={{ trip, setTrip }}>{children}</TripContext.Provider>;
};
